import React from 'react';
import { Loader2, CheckCircle, Cloud, AlertCircle } from 'lucide-react';

const formatLastSaved = (date) => {
  if (!date) return '';
  const now = new Date();
  const diffMs = now - date;
  const diffSecs = Math.floor(diffMs / 1000);
  const diffMins = Math.floor(diffMs / 60000);

  if (diffSecs < 10) return 'just now';
  if (diffSecs < 60) return `${diffSecs}s ago`;
  if (diffMins < 60) return `${diffMins}m ago`;
  return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
};

export const SaveStatusIndicator = ({ saveStatus, lastSaved, isNewAgent }) => {
  if (isNewAgent) return null;

  switch (saveStatus) {
    case 'saving':
      return (
        <div className="flex items-center gap-2 text-blue-400 text-sm" data-testid="save-status-saving">
          <Loader2 className="w-3.5 h-3.5 animate-spin" />
          <span>Saving...</span>
        </div>
      );
    case 'saved':
      return (
        <div className="flex items-center gap-2 text-green-400 text-sm" data-testid="save-status-saved">
          <CheckCircle className="w-3.5 h-3.5" />
          <span>Saved {lastSaved ? formatLastSaved(lastSaved) : ''}</span>
        </div>
      );
    case 'unsaved':
      return (
        <div className="flex items-center gap-2 text-yellow-400 text-sm" data-testid="save-status-unsaved">
          <Cloud className="w-3.5 h-3.5" />
          <span>Unsaved changes</span>
        </div>
      );
    case 'error':
      return (
        <div className="flex items-center gap-2 text-red-400 text-sm" data-testid="save-status-error">
          <AlertCircle className="w-3.5 h-3.5" />
          <span>Save failed</span>
        </div>
      );
    default:
      return null;
  }
};
